// extracted by mini-css-extract-plugin
export default {"loaderWrap":"App_loaderWrap__-aqVy"};